module.exports = __webpack_public_path__ + "static/img/hb_42-min.84e3553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_42-min.png
// module id = ULol
// module chunks = 1